<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<cnHeader></cnHeader>
		<div class="page_content">
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/cn">首页</a><span class="space">/</span><a href="/cn/faq">FAQ</a>
				</div>
				<cnPubtips></cnPubtips>
			</div>
			<!--面包屑与公共提醒-结束-->
			<!--页面内容-开始-->
			<div class="faq_content">
				<div class="title">FAQ</div>
				<div class="faq_list_box">
					
					<h1>{{faqDetail.Title}}</h1>
					<div class="faq_detail" v-html="faqContent">
					</div>
					
				</div>
			</div>
			<!--页面内容-结束-->
		</div>
		<cnFooter></cnFooter>
	</div>
</template>


<script>
	import {
		getFaqDetail,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import cnHeader from '@/components/cn_header.vue'
	import cnPubtips from '@/components/cn_pubtips.vue'
	import cnFooter from '@/components/cn_footer.vue'
	export default {
		name: 'CN_FaqDetail',
		mixins: [mixin],
		components: {
			cnHeader,
			cnPubtips,
			cnFooter,
		},
		data() {
			return {
				fullscreenLoading: true, //loading状态
				language: 'cn', //语言版本
				terminal: 'pc', //终端，pc
				faqDetail: [], //详情
				faqContent: '',	//富文本详情
			}
		},
		created() {
			this.Id = this.$route.query.Id
			
			this.getData()
		},
		methods: {
			//获取数据
			async getData() {
				const { data: res } = await getFaqDetail(this.language, this.Id)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.faqDetail = res.data
					
					//热词替换
					this.faqContent = this.patchReplace(
					this.faqDetail.RecreationHotKeywords,
					this.faqDetail.Content,
					'/cn/recreation/detail?Id=')
				} else {
					this.errMessage = res.errmsg
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;
	}
</style>